import { FC, useEffect, useReducer, useState } from 'react'
import React from 'react'
import * as pageUtils from './__details.utils'
import { REQUEST_CONFIGS_KEYS } from '@services/constants'
import { CheckboxList, RadioList, SelectList } from '@utils/request'
import Collapse from '@components/ui/collapse'
import Modal from '@components/ui/modal'
import * as formUtils from '@components/requestForms/__forms.utils'
import { joinClasses, makeClasses } from '@utils/styles'
import { formatNumberWithSpaces } from '@components/requestForms/__forms.utils'
import { Colors } from '@utils/css-variables'
import Breakpoints from '@utils/breakpoints'
import Text from '@components/ui/text'
import { populateRequestConfigsState } from '@services/store/request'
import { useAppDispatch, useAppSelector } from '@services/store'
import {
	inputReducer,
	useInitialFormState
} from '@components/requestForms/GR6_LandDevelopmentWorkPermit/reducer.form'
import * as pageUtilsForm from '@components/requestForms/__forms.utils'
import * as utilsList from '@components/requestForms/GR6_LandDevelopmentWorkPermit/__index.utils'
import Step1TypeDeDemande from '@components/requestForms/GR6_LandDevelopmentWorkPermit/Step1TypeDeDemande'
import Step2Localisation from '@components/requestForms/GR6_LandDevelopmentWorkPermit/Step2Localisation'
import Step3TypeUtilisation from '@components/requestForms/GR6_LandDevelopmentWorkPermit/Step3TypeUtilisation'
import Step4_1LandDevelopmentWork from '@components/requestForms/GR6_LandDevelopmentWorkPermit/Step4_1LandDevelopmentWork'
import Step4_2LandDevelopmentWork from '@components/requestForms/GR6_LandDevelopmentWorkPermit/Step4_2LandDevelopmentWork'
import Step4_5LandDevelopmentWork from '@components/requestForms/GR6_LandDevelopmentWorkPermit/Step4_5LandDevelopmentWork'
import Step5InformationsTravaux from '@components/requestForms/GR6_LandDevelopmentWorkPermit/Step5InformationsTravaux'
import Step4_3LandDevelopmentWork from '@components/requestForms/GR6_LandDevelopmentWorkPermit/Step4_3LandDevelopmentWork'
import Step4_4LandDevelopmentWork from '@components/requestForms/GR6_LandDevelopmentWorkPermit/Step4_4LandDevelopmentWork'

const LandDevelopmentWorkPermitFormDetails: FC<pageUtils.Props> = ({
	pageAssets,
	request
}) => {
	const { incidentForm } = request
	const [isModalOpen, setIsModalOpen] = useState<boolean>(false)
	const getLabelFromList = (list: SelectList[], value) => {
		return list?.find((element) => element.value == value?.toString())?.label
	}

	// LandDevelopmentWorkPermitForm
	const radioListWhatToDo: RadioList[] = utilsList.radioListWhatToDo(pageAssets)

	const renderStep4FormLandDevelopmentWork = (whatToDo) => {
		switch (whatToDo.toString()) {
			//* isBalconyOrPorchPermitGR6_1
			case REQUEST_CONFIGS_KEYS.whatToDoLandDevWorkPermit.GR6_1BalconyOrPorch: {
				return (
					<Step4_1LandDevelopmentWork
						{...{
							pageAssets,
							pageUtils: pageUtilsForm,
							formInputs,
							isSummaryStep: true
							// ******
						}}
						errors={[]}
						updateInput={() => {}}
						onFixError={() => {}}
						updateCheckBoxInput={() => {}}
					/>
				)
			}
			//* isResidentialLandPermitGR6_2
			case REQUEST_CONFIGS_KEYS.whatToDoLandDevWorkPermit
				.GR6_2ResidentialLand: {
				return (
					<Step4_2LandDevelopmentWork
						{...{
							pageAssets,
							pageUtils: pageUtilsForm,
							formInputs,
							isSummaryStep: true
							// ******
						}}
						errors={[]}
						updateInput={() => {}}
						onFixError={() => {}}
						updateCheckBoxInput={() => {}}
					/>
				)
			}

			//* isResidentialLandPermitGR6_3
			case REQUEST_CONFIGS_KEYS.whatToDoLandDevWorkPermit.GR6_3ParkingLot: {
				return (
					<Step4_3LandDevelopmentWork
						{...{
							pageAssets,
							pageUtils: pageUtilsForm,
							formInputs,
							isSummaryStep: true
							// ******
						}}
						errors={[]}
						updateInput={() => {}}
						onFixError={() => {}}
						updateCheckBoxInput={() => {}}
					/>
				)
			}

			//* isResidentialLandPermitGR6_4
			case REQUEST_CONFIGS_KEYS.whatToDoLandDevWorkPermit.GR6_4BoatDock: {
				return (
					<Step4_4LandDevelopmentWork
						{...{
							pageAssets,
							pageUtils: pageUtilsForm,
							formInputs,
							isSummaryStep: true
							// ******
						}}
						errors={[]}
						updateInput={() => {}}
						onFixError={() => {}}
						updateCheckBoxInput={() => {}}
					/>
				)
			}

			case REQUEST_CONFIGS_KEYS.whatToDoLandDevWorkPermit.GR6_5Divers: {
				return (
					<Step4_5LandDevelopmentWork
						{...{
							pageAssets,
							pageUtils: pageUtilsForm,
							formInputs,
							isSummaryStep: true
							// ******
						}}
						errors={[]}
						updateInput={() => {}}
						onFixError={() => {}}
						updateCheckBoxInput={() => {}}
					/>
				)
			}
		}
	}

	const dispatch = useAppDispatch()

	if (request.incidentForm) {
		dispatch(populateRequestConfigsState(request.incidentForm))
	} else {
		dispatch(populateRequestConfigsState({}))
	}

	const answers = useAppSelector((state) => state.request.configs)

	// ******************************
	// Initialize INPUTS state REDUCER
	const initialState = useInitialFormState()

	const [formInputs, dispatchFormInputs] = useReducer(
		inputReducer,
		initialState
	)

	const { whatToDo, isSameLocation } = formInputs

	// useEffect(() => {
	// 	if (answers && Object.keys(answers).length > 0) {
	// 		const initialState = useInitialFormState()
	// 		dispatchFormInputs({ type: 'RESET', payload: initialState })
	// 	}
	// }, [answers])

	return (
		<>
			{/* Question 1 */}
			<div>
				<strong>{pageAssets.request_form_what_would_you_like_to_do}</strong>
				<br />
				{/* <span>
					{getLabelFromList(radioListWhatToDo, incidentForm?.whatToDo)}
				</span> */}
				<span className={pageUtilsForm.classes.answerURB}>
					<Text content={getLabelFromList(radioListWhatToDo, whatToDo.value)} />
				</span>
			</div>

			<p style={{ marginBottom: '20px' }}>
				<span
					onClick={() => {
						setIsModalOpen(true)
					}}
					className={pageUtils.classes.viewDetailsSpan}
				>
					<b>{pageAssets.request_form_show_details}</b>
				</span>
			</p>

			<Modal
				// cancelButtonText={pageAssets?.close_label}
				primaryButtonText={pageAssets?.close_label}
				isOpen={isModalOpen}
				onCancelBtn={() => {
					setIsModalOpen(false)
				}}
				onPrimaryButton={() => {
					setIsModalOpen(false)
				}}
				onSetIsOpen={() => {}}
				alignBtn={'left'}
				title={pageAssets?.request_form_request_details}
				showExitBtn
			>
				<div>
					<div
						style={{ marginTop: '-20px' }}
						className={joinClasses([
							pageUtils.classes.collapse,
							pageUtils.classes.summarySubTitles
						])}
					>
						<>
							<Collapse
								id={1}
								buttonText={pageAssets?.request_form_type_de_demandes}
								key={`request_form_type_de_demandes`}
								isOpen={false}
							>
								<Step1TypeDeDemande
									{...{
										pageAssets,
										pageUtils: pageUtilsForm,
										formInputs,
										isSummaryStep: true
										// err[],
										// ()=>{},
										// ()=>{}
									}}
									errors={[]}
									updateInput={() => {}}
									onFixError={() => {}}
								/>

								<br />
							</Collapse>
							<Collapse
								id={2}
								buttonText={pageAssets?.request_form_request_location}
								key={`request_form_request_location`}
								isOpen={false}
							>
								<Step2Localisation
									{...{
										pageAssets,
										pageUtils: pageUtilsForm,
										formInputs,
										isSummaryStep: true,
										// ******
										isAddressOutsideLaval: false
										// showAdresseBlock:
										// 	isSameLocation?.toString() == 'false' ? true : false
									}}
									showAdresseBlock={
										isSameLocation?.value?.toString() == 'false' ? true : false
									}
									errors={[]}
									updateInput={() => {}}
									onFixError={() => {}}
									inputs={[]}
									onSetInputs={() => {}}
									formFilesInputs={[]}
									updateFileInput={() => {}}
									updateUploadedFilesMap={() => {}}
									onSetErrorFromFileComponent={() => {}}
									applicantLocation={request.incidentForm?.applicant}
								/>

								<br />
							</Collapse>
							<Collapse
								id={3}
								buttonText={pageAssets?.request_form_type_of_use}
								key={`request_form_type_of_use`}
								isOpen={false}
							>
								<>
									<Step3TypeUtilisation
										{...{
											pageAssets,
											pageUtils: pageUtilsForm,
											formInputs,
											isSummaryStep: true
											// ******
										}}
										errors={[]}
										updateInput={() => {}}
										formFilesInputs={[]}
										updateFileInput={() => {}}
										updateUploadedFilesMap={() => {}}
										onSetErrorFromFileComponent={() => {}}
									/>
								</>
								<br />
							</Collapse>
							<Collapse
								id={4}
								buttonText={pageAssets?.request_form_land_developement}
								key={`request_form_land_developement`}
								isOpen={false}
							>
								{/* Render the appropriate form for land development work based on the value of 'whatToDo' */}
								{/***   ! important  ***/}
								{renderStep4FormLandDevelopmentWork(whatToDo.value)}
								{/** Done for GR6.1 & GR6.2 & GR6.5 **/}

								<br />
							</Collapse>
							<Collapse
								id={5}
								buttonText={pageAssets?.request_form_information_on_the_work}
								key={`request_form_information_on_the_work`}
								isOpen={false}
							>
								<Step5InformationsTravaux
									{...{
										pageAssets,
										pageUtils: pageUtilsForm,
										formInputs,
										isSummaryStep: true
										// ******
									}}
									errors={[]}
									updateInput={() => {}}
									onFixError={() => {}}
								/>

								<br />
							</Collapse>
						</>
					</div>
				</div>
			</Modal>
		</>
	)
}

export default LandDevelopmentWorkPermitFormDetails
